import SeriesBadge, { SeriesBadgeProps } from '../SeriesBadge'
import { classNames } from '@/util/tailwindHelpers'

type Props = SeriesBadgeProps & {
  className?: string
}
const baseClassName = 'border-arcadeGreen !text-xs'

const ArcadeSeriesBadge = ({ className, ...props }: Props) => {
  return (
    <SeriesBadge className={classNames(baseClassName, className)} {...props} />
  )
}

export default ArcadeSeriesBadge
